
const digest = '8ac92cc4eb047cc1218726bb56c9e32b44e9abf0c21c0acd8ee2e670859845a4';
const classes = {"wrapper":"_wrapper_1en3j_1","greyBox":"_greyBox_1en3j_15","whiteBox":"_whiteBox_1en3j_29"};
const css = `._wrapper_1en3j_1 {
  font-family: Rubik, "sans-serif";
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  margin: -34px -24px;
}
._wrapper_1en3j_1 span {
  font-weight: 600;
}
._wrapper_1en3j_1 img {
  height: 50px;
}
._wrapper_1en3j_1 ._greyBox_1en3j_15 {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f2f4f7;
  padding: 24px;
  width: 100%;
  flex-direction: column;
  gap: 10px;
  text-align: center;
}
._wrapper_1en3j_1 ._greyBox_1en3j_15 p {
  margin-bottom: 0;
}
._wrapper_1en3j_1 ._whiteBox_1en3j_29 {
  padding-bottom: 24px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  